import { Form as FinalForm, Field } from "react-final-form";
import { Form, Button, Grid, Segment } from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import { RootStoreContext } from "../../../app/stores/rootStore";
import { ISettlementFilter } from "../../../app/models/report";
import SelectInputOnSearchChange from "../../../app/common/form/SelectInputOnSearchChange";
import DateInput from "../../../app/common/form/DateInput";
import { useContext, useState } from "react";
import React from "react";

const SettlementFilter = () => {
  //variables para uso la informacion del userStore
  const rootStore = useContext(RootStoreContext);
  const {
    settlementFilter,
    btFilterSettlement,
    getBrokersAutocomplete,
    brokersAutocomplete,
    setSettlementFilter,
  } = rootStore.reportStore;

  const [settlementFilterForm] = useState<ISettlementFilter>({
    brokerId: settlementFilter.brokerId,
    dateFrom: settlementFilter.dateFrom,
    dateTo: settlementFilter.dateTo,
  });

  const handleFinalFormSubmit = (values: any) => {
    setSettlementFilter(values);
  };

  const handleBroker = async (value: any) => {
    getBrokersAutocomplete(value);
  };

  return (
    <Segment className="grayborder">
      <FinalForm
        initialValues={settlementFilterForm}
        onSubmit={handleFinalFormSubmit}
        render={({ handleSubmit }) => (
          <Form onSubmit={handleSubmit}>
            <div className="filter">
              <Grid relaxed doubling columns={2}>
                <Grid.Row columns={3}>
                  <Grid.Column>
                    <label>Agente</label>
                    <Field
                      name="brokerId"
                      value={settlementFilterForm.brokerId}
                      component={SelectInputOnSearchChange}
                      search={true}
                      autoComplete="off"
                      options={brokersAutocomplete}
                      onSearchChange={handleBroker}
                    />
                  </Grid.Column>
                  <Grid.Column>
                    <label>Fecha consumo (dd/mm/yyyy)</label>
                    <Form.Group widths="equal">
                      <Field
                        name="dateFrom"
                        placeholder="desde"
                        value={settlementFilterForm.dateFrom}
                        component={DateInput}
                      />
                      <Field
                        name="dateTo"
                        placeholder="hasta"
                        value={settlementFilterForm.dateTo}
                        component={DateInput}
                      />
                    </Form.Group>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
              <br />
              <Button
                loading={btFilterSettlement}
                disabled={btFilterSettlement}
                className="ui primary button filterbutton"
                color="blue"
                type="submit"
                content="Buscar"
              />
            </div>
          </Form>
        )}
      />
    </Segment>
  );
};

export default observer(SettlementFilter);
